<h3 class="preset-title-3 md:preset-title-2 text-center text-white">TÉRMINOS Y CONDICIONES PARA LA DINÁMICA “Fórmula Tonicorp”</h3>

<div class="preset-body-3 md:preset-body-2 mt-4 flex flex-col gap-6 text-white">
  <article class="flex flex-col gap-4">
    <p>
      Para participar en la dinámica “Fórmula Tonicorp” se deberá dar lectura íntegra de las siguientes bases y cumplir totalmente con los requisitos y condiciones aquí establecidas, lo cual implicará la comprensión y
      aceptación de las mismas. La dinámica se ejecutará en el sitio web www.formulatonicorp.com y la participación en la dinámica implicará la aceptación a los términos de uso de esta dinámica por parte del
      Participante.
    </p>

    <p>
      Términos y condiciones de participación para la dinámica: “Fórmula Tonicorp”, y DISTRIBUIDORA IMPORTADORA DIPOR S.A.; (en adelante <strong>"Tonicorp"</strong>), estos en conjunto (en adelante Los
      <strong>"Organizadores"</strong>), organizan la Dinámica: “Fórmula Tonicorp” (en adelante la <strong>"Dinámica"</strong>), que quedará sujeta a los siguientes términos y condiciones (en adelante las
      <strong>"Bases"</strong>):
    </p>
  </article>

  <article class="flex flex-col gap-4">
    <p>
      DISTRIBUIDORA IMPORTADORA DIPOR S.A, conocida por su nombre comercial como <strong>Tonicorp</strong>, con domicilio en Vía Daule # Km 10.5 Guayaquil, Ecuador, para cualquier duda o aclaración con a los correos
      electrónicos
      <a href="mailto:javier.ochoa@tonicorp.com">javier.ochoa&#64;tonicorp.com</a>
    </p>
  </article>

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">1. ORGANIZADOR DE LA PROMOCIÓN:</h4>
    <p>Serán considerados como Participantes en la Dinámica, las personas físicas que cumplan con los requisitos y condiciones establecidas en las Bases.</p>

    <p>REQUISITOS DE LOS PARTICIPANTES Y ACREEDORES AL INCENTIVO:</p>

    <p>
      Pueden participar en la <strong>Dinámica</strong> todas aquellas personas que se dediquen a ser vendedores, supervisores, jefes y gerentes de la fuerza de ventas de Ecuador, donde se seleccionarán y/o invitaran a
      participar en la <strong>Dinámica</strong> “Fórmula Tonicorp”, deberán cumplir con los requisitos para ser Acreedores del Incentivo, ser; mayores de edad conforme a las leyes de Ecuador, que cuenten con
      identificación oficial que acredite su fecha de nacimiento (credencial para votar, pasaporte, cartilla del servicio militar, cédula profesional o alguna expedida por institución gubernamental con validez oficial),
      y que realicen el registro en el sitio web <a href="https://www.formulatonicorp.com">www.formulatonicorp.com</a> a través del correo de registro enviado al correo electrónico registrado, y cumplan con las
      condiciones establecidas en las <strong>Bases</strong> (en adelante los <strong>"Participantes"</strong>).
    </p>

    <p>
      Los <strong>Participantes</strong> otorgan a los <strong>Organizadores</strong> la autorización para contactarlos personalmente, y recolectar los siguientes datos personales únicamente para fines relacionados con
      la <strong>Dinámica</strong>:
    </p>

    <ul>
      <li>Nombre completo</li>
      <li>Dirección de correo electrónico</li>
      <li>Teléfono</li>
    </ul>

    <p>
      No podrán participar en la <strong>Dinámica</strong> quienes no tengan la mayoría de edad al inicio de la vigencia de ésta, además, deberán cumplir con los requisitos establecidos en las <strong>Bases</strong>; y
      no deberán incurrir en algún supuesto de descalificación y/o limitantes de participación.
    </p>

    <p>
      El otorgamiento de cualquiera de los Incentivos aquí estipulados estará condicionado al cumplimiento de lo establecido en las presentes <strong>Bases</strong> y de las leyes y regulaciones aplicables, así como las
      cláusulas del presente reglamento. Los <strong>Organizadores</strong> se reservan el derecho de descalificar y/o exigir la devolución de los beneficios otorgados a aquellos <strong>Participantes</strong> que
      directa o indirectamente incumpla las normas y condiciones aquí establecidas.
    </p>

    <p>
      Solamente participarán en la presente promoción aquellas personas de la fuerza de ventas de Ecuador, y que sean seleccionados y/o invitados a participar en la <strong>Dinámica</strong> “Fórmula Tonicorp” por
      <strong>Tonicorp</strong>. Deberán cumplir con los requisitos para ser merecedores del <strong>Incentivo</strong>.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">2. DEFINICIONES:</h4>
    <p>En adelante las presentas <strong>Bases</strong> se entenderá por:</p>

    <p><strong>Dinámica:</strong> La actividad promocional aquí regulada.</p>

    <p><strong>Sitio Web:</strong> www.formulatonicorp.com sujetándose los participantes a sus Políticas de uso a las presentes Bases y al Aviso de Privacidad al momento de uso e ingreso a la misma.</p>

    <p>
      <strong>Registro Individual de Participante:</strong> Se integra de los datos personales verídicos proporcionados voluntariamente por el Participante dentro del <strong>Sitio Web</strong>, este registro se integra
      con el nombre, dirección de correo electrónico y teléfono de contacto y se compone con una identidad para su uso y una clave de acceso válido con el propósito de desarrollar la <strong>Mecánica</strong> de la
      promoción.
    </p>

    <p>
      <strong>Acreedor al Incentivo:</strong> Es el <strong>participante</strong> que cumple con los requisitos para ser considerado Participante en la Dinámica de la promoción conforme a las <strong>Bases</strong>. Se
      considerará como posible Acreedor al Incentivo, hasta que se hayan comprobado que logró realizar todas a las actividades descritas en la Mecánica de las presentes <strong>Bases</strong> y no estar en algún supuesto
      de limitante y/o supuesto de descalificación.
    </p>

    <p><strong>Incentivo:</strong> Serán los bienes o servicios que se especifican en el Capítulo 7. Denominado Incentivo.</p>

    <p>
      Todos los participantes que realicen las diferentes actividades que se proponen en el programa tendrán la posibilidad de ganar puntos que se podrán redimir por diferentes incentivos como premios o certificados
      digitales como, por ejemplo: Artículos de entretenimiento y cuidado personal, Gift Card, Spotify, Netflix, Amazon Prime Video y Disney +.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">3. SOBRE EL OBJETO DEL PROGRAMA:</h4>
    <p>
      Tonicorp seleccionará e invitará a participar a los "usuarios" a inscribirse en un programa de fidelización a través del cual podrán interactuar y al participar le permitirá a cada usuario ganar diferentes
      insignias, premios o incentivos, además entender mejor su labor y optimizar sus ventas poniendo a su alcance las herramientas que lo ayudarán a crecer significativamente.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">4. UBICACIÓN GEOGRÁFICA:</h4>
    <p>La presente dinámica se desarrollará en Ecuador.</p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">5. VIGENCIA DE EL PROGRAMA:</h4>
    <p>
      EL PROGRAMA es por tiempo ilimitado, tendrá inicio el
      <strong>1 de junio del 2025 y finalizará con previo aviso</strong>.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">6. DE LOS INCENTIVOS:</h4>
    <p>
      Todos los participantes que realicen las diferentes actividades que se proponen en el programa tendrán la posibilidad de ganar puntos que se podrán redimir por diferentes incentivos como premios o certificados
      digitales como, por ejemplo: Artículos de entretenimiento y cuidado personal, Gift Card, Spotify, Netflix, Amazon Prime Video y Disney +.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">7. FORMA DE PARTICIPACIÓN:</h4>
    <p>
      Todo participante que haya sido seleccionado por <strong>Tonicorp</strong>, que desee participar en la <strong>Dinámica</strong> y utilizar los beneficios aquí descritos, deberá tener conocimiento de estas
      <strong>Bases</strong>, ya que el reclamo, la aceptación en la forma que se indica en este documento, implica la forzosa e ineludible obligación de conocer las condiciones y la forma de participación, así como las
      condiciones, limitaciones y responsabilidades en cuanto al <strong>Incentivo</strong> ofrecido en la <strong>Dinámica</strong>. Por lo anterior y para todos los efectos legales, <strong>Tonicorp</strong> entenderá
      que la manifestación de voluntad de la aceptación de ese conocimiento se verificará por el hecho de la aceptación de convertirse en Participante, en cuyo caso, los Organizadores podrán exigir al
      <strong>Participante</strong>, que, mediante documento escrito, manifieste dicha declaración y a su vez se adhiera por completo a todas y cada una de las cláusulas de las presentes <strong>Bases</strong>, sólo si
      lo considera necesario.
    </p>

    <p>
      Si un <strong>Participante</strong> no se adhiere o no demuestra su voluntad de aceptar estas condiciones, los <strong>Organizadores</strong> no asumirán ningún tipo de responsabilidad, exonerándolos de toda
      obligación y de reconocer los beneficios aquí descritos.
    </p>

    <p>La <strong>Mecánica</strong> para participar en la <strong>Dinámica</strong> es la siguiente:</p>

    <ul>
      <li><strong>Tonicorp</strong> seleccionará las regiones, Cedis y rutas, dentro de Ecuador donde se realizará la ejecución de la <strong>Dinámica</strong>.</li>
      <li>
        El Participante deberá registrarse en el correo de bienvenida que será enviado a su correo electrónico, donde lo llevará a completar el registro en el sitio
        <a href="https://www.formulatonicorp.com">www.formulatonicorp.com</a>, aceptar el reglamento de la <strong>Dinámica</strong> y el consentimiento para uso de los datos personales. Para el registro, el
        <strong>Participante</strong> utilizará correo electrónico y contraseña.
      </li>
      <li>
        El Participante al registrarse podrá acceder a su perfil, visualización de cumplimiento de metas, retos de cumplimiento rápido (sprints), trofeos mensuales por cumplimiento de desafíos puntuales, podio general de
        participantes y entrenamientos de capacitación.
      </li>
    </ul>

    <p>
      Cada sección puede hacer acreedor a los pilotos de puntos que podrán canjear en distintas categorías de incentivos; los usuarios solamente ganarán puntos por su cumplimiento veraz de las instrucciones entregadas
      durante el mes.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">8. RESPONSABILIDAD Y RESTRICCIONES:</h4>
    <p>
      En la publicidad de la <strong>Dinámica</strong> se ha señalado: <strong>“Aplican restricciones. Ver reglamento <a>aquí</a>”</strong>, en señal de que la intervención de los <strong>Participantes</strong>, así como
      la propia promoción y el beneficio, están sujetos a condiciones y limitaciones. Estas condiciones y restricciones son las que se indican en este reglamento y las que se señalan en esa página.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">9. RESTRICCIONES Y SUPUESTOS DE DESCALIFICACIÓN:</h4>
    <p>Esta promoción es válida en Ecuador únicamente podrán participar los <strong>Participantes</strong> que hayan sido contactados por Tonicorp.</p>

    <ul>
      <li>La participación de cualquier menor de edad durante la <strong>Vigencia</strong> de la <strong>Promoción</strong>.</li>
      <li>
        Proporcionar o afirmar cualquier dato que no sea cierto o verificable como cierto por el
        <strong>Participante</strong>.
      </li>
      <li>El <strong>Participante</strong> solo podrá tener un registro en la <strong>Plataforma</strong>, en caso de tener dos, ambos serán cancelados y dejará de participar en la <strong>Dinámica</strong>.</li>
      <li>
        El <strong>Participante</strong> podrá ser acreedor de los puntos en cada <strong>dinámica</strong> una sola vez por la aprobación correcta del reto realizado, con posibilidad de nulidad en caso de rectificarse
        por parte del <strong>organizador</strong> algún inconveniente de configuración dentro de la plataforma.
      </li>
      <li>
        Por la negativa u omisión de entrega de documentos o información completos y legibles que le sean requeridos vía correo electrónico o vía telefónica al número proporcionado por el <strong>Participante</strong>.
      </li>
      <li>Todo <strong>Participante</strong> que participe o ejecute conductas fraudulentas.</li>
      <li>Todo <strong>Participante</strong> que incumpla con las presentes <strong>Bases</strong>.</li>
      <li>
        Cualquier ataque o intento de alteración o manipulación al sistema informático, o a la
        <strong>Plataforma</strong> o al lugar en el cual se encuentre radicada la misma, genera la anulación del <strong>Participante</strong>.
      </li>
    </ul>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">10. REGULACIÓN DE LA DINÁMICA:</h4>
    <p>
      La presente promoción se rige por este Reglamento, y en forma supletoria y complementaria se tiene por incorporada la legislación nacional, la jurisprudencia judicial y administrativa, así como las resoluciones de
      la Procuraduría del consumidor, en cuanto sean aplicables. El patrocinador se reserva el derecho de determinar de acuerdo con los intereses de <strong>Tonicorp</strong>, así como de la actividad y de los derechos
      de los consumidores, los casos en que se incumpla con los artículos anteriores. Las pruebas que sustenten actos como los descritos en los puntos anteriores, serán las que de acuerdo con los principios y leyes
      judiciales, sean las más comunes y/o permitidas por los Tribunales de Justicia. Cualquier asunto que se presente con la <strong>Dinámica</strong> y que no esté previsto en el presente reglamento, será resuelto por
      los <strong>Organizadores</strong>, en estricto apego a las leyes de Ecuador.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">11. LIMITACIÓN DE RESPONSABILIDAD:</h4>
    <p>
      <strong>Tonicorp</strong> no asume ningún tipo de responsabilidad con respecto a los riesgos inherentes al goce y disfrute de los Incentivos. <strong>Tonicorp</strong> no será responsable por daños, perjuicios o
      pérdidas ocasionados por los participantes. Además de lo anterior <strong>Tonicorp</strong> no asume ninguna clase de responsabilidad por la ejecución de los premios aquí otorgados objeto de la presente promoción.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">12. TRATAMIENTO DE DATOS PERSONALES:</h4>
    <p>
      En caso de que decida participar en la <strong>dinámica</strong>, deberá registrarse o inscribirse a cualquiera de nuestros programas, promociones, trivias, encuestas o entrar a ciertos apartados en los cuales se
      solicitará que voluntariamente proporcione sus datos para las distintas finalidades descritas en la política de privacidad de datos.
    </p>
    <p>
      Para participar en la dinámica se recabarán los siguientes datos personales: nombre completo, correo electrónico, edad, género, teléfono. Adicionalmente, es importante mencionar que los nombres y fotografías de los
      participantes pueden ser cargados en la plataforma con el fin de identificar y reconocer a los mismos durante el desarrollo del evento o actividad correspondiente. Se garantiza que estos datos serán tratados con la
      máxima diligencia y cuidado, respetando siempre los derechos y libertades fundamentales de los participantes, en especial su derecho a la privacidad y a la protección de sus datos personales.
    </p>
    <p>
      Se informa que, en todo momento, los participantes tendrán control sobre sus datos personales y podrán ejercer sus derechos de acceso, rectificación, cancelación y oposición en cualquier momento, de conformidad con
      la ley aplicable y las políticas de tratamiento de datos personales establecidas por la plataforma.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">13. PLAZO Y PROCEDIMIENTO PARA RECLAMOS:</h4>
    <p>
      En caso de que alguno de los <strong>Participantes</strong> de la presente promoción se considere afectado por algún aspecto relacionado por la presente promoción, tendrá que presentar su reclamo dentro de 60 días
      naturales que se contarán a partir del día en que finalice la Dinámica. El reclamo tendrá que presentarse por medio del correo de <strong>Tonicorp</strong>:
      <a href="mailto:javier.ochoa@tonicorp.com">javier.ochoa&#64;tonicorp.com</a> indicando las razones de su inconformidad y si la hubiera, ofreciendo la prueba pertinente. Transcurrido el plazo aquí indicado caducará
      la acción de reclamo.
    </p>

    <p>Para la correcta gestión de su reclamo, su comunicación deberá incluir como mínimo la siguiente información:</p>

    <ul>
      <li><strong>Datos del Titular del Reclamo:</strong> Nombre completo del reclamante y un medio de contacto válido (dirección física o correo electrónico) para notificar la respuesta a su solicitud.</li>
      <li>
        <strong>Documentación de Identificación y Representación (si aplica):</strong> Copia legible de su documento de identidad o, en caso de actuar a través de un representante legal, el documento que acredite dicha
        representación.
      </li>
      <li><strong>Descripción Detallada de la Inconformidad:</strong> Exposición clara y precisa de los motivos de su reclamo, identificando los hechos y aspectos específicos que generan su insatisfacción.</li>
      <li><strong>Información Adicional Relevante:</strong> Cualquier otro documento o dato que contribuya a una mejor comprensión de los hechos que originan el reclamo.</li>
    </ul>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">14. SOBRE LA SUSPENSIÓN DE LA DINÁMICA Y OTRAS PRERROGATIVAS DEL PATROCINADOR:</h4>
    <p>
      El patrocinador, podrá postergar la fecha de inicio de la <strong>Dinámica</strong>. Además, podrá cancelarla en forma indefinida o definitiva, de forma parcial o total en cualquier momento sin responsabilidad,
      dicha decisión será comunicada por medio de la página web: www.formulatonicorp.com. Podrá suspender de forma inmediata la <strong>Dinámica</strong>, sin asumir responsabilidad alguna, si se llegasen a detectar
      mecanismos de cualquier naturaleza que afecten o puedan afectar gravemente los intereses de <strong>Tonicorp</strong> o de la <strong>Dinámica</strong>. Igualmente podrá tomar todo tipo de acciones a fin de evitar
      que los Participantes se valgan y aprovechen de la <strong>Dinámica</strong> en forma fraudulenta o ilícita, pudiendo denunciar cualquier hecho de tal naturaleza que afecte a <strong>Tonicorp</strong>. En caso de
      participaciones en perjuicio de la <strong>Dinámica</strong>, el patrocinador se reserva el derecho de establecer todo tipo de acciones civiles y penales que se deriven de dichas actuaciones.
      <strong>Tonicorp</strong> se reserva el derecho de establecer todo tipo de acción para reclamarlos de vuelta, independientemente de las acciones civiles y penales que se deriven. <strong>Tonicorp</strong> podrá
      introducir todas las medidas de seguridad que considere convenientes para el buen desarrollo de la <strong>Dinámica</strong>, y suspenderá en forma inmediata esta promoción sin asumir responsabilidad alguna, si se
      llegasen a detectar defraudaciones o cualquier otra irregularidad que suceda o si se presentara una circunstancia de fuerza mayor que afecte gravemente los intereses de <strong>Tonicorp</strong>. Esta circunstancia
      se comunicará públicamente, fecha a partir de la cual la <strong>Dinámica</strong> cesará.
    </p>
    <p>
      <strong>Tonicorp</strong> se reserva el derecho de excluir a un <strong>Participante</strong> durante cualquier momento de <strong>Vigencia</strong> de la <strong>Dinámica</strong> si llegase a detectar un uso
      indebido de la promoción, información alterada o fraudulenta, o publique apalancado en la <strong>Dinámica</strong> en cualquiera de sus medios de información o comentarios que atenten contra la integridad de
      <strong>Tonicorp</strong>.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">15. RELACIÓN ENTRE LAS PARTES:</h4>
    <p>
      La participación en la presente Dinámica y la obtención de cualquier beneficio o incentivo derivado de la misma se entenderán como un reconocimiento o estímulo específico dentro del marco de esta actividad
      promocional. En tal virtud, y de conformidad con la legislación laboral y civil ecuatoriana, se aclara expresamente que:
    </p>

    <ul>
      <li>
        Para aquellos participantes que mantengan una relación laboral con Tonicorp o sus empresas relacionadas, la participación y los beneficios obtenidos no tendrán la naturaleza de salario, remuneración adicional, ni
        constituirán una modificación o mejora de sus condiciones laborales contractuales o legales.
      </li>
      <li>
        Para aquellos participantes que presten servicios a Tonicorp o sus empresas relacionadas bajo cualquier otra figura jurídica sin relación laboral (colaboradores, prestadores de servicios independientes, etc.), la
        participación y los beneficios obtenidos no implicarán la existencia de una relación laboral, ni modificarán o mejorarán los términos y condiciones de su vinculación contractual o de prestación de servicios.
      </li>
      <li>
        Ninguna disposición de la presente Dinámica se interpretará como creadora de una relación laboral, de representación, de agencia o de cualquier otra índole diferente a la estrictamente promocional entre Tonicorp
        y los Participantes. La relación entre las partes se limitará al desarrollo y cumplimiento de los términos y condiciones de esta Dinámica, finalizando con la conclusión de la misma y la entrega de los beneficios
        correspondientes.
      </li>
    </ul>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <h4 class="preset-title-4 md:preset-title-3">16. MODIFICACIONES AL REGLAMENTO:</h4>
    <p>
      <strong>Tonicorp</strong> se reserva el derecho de modificar este reglamento en cualquier momento para introducir todas aquellas modificaciones necesarias para la buena marcha de la <strong>Dinámica</strong>, así
      como los intereses de los <strong>Participantes</strong>. Las anteriores circunstancias se comunicarán en la misma forma que el presente reglamento, fecha a partir de la cual la <strong>Dinámica</strong> cesará, o
      la reforma al reglamento quedará vigente.
    </p>
  </article>

  <hr class="text-white" />

  <article class="flex flex-col gap-4">
    <p>Listado de Cedis:</p>
    <ul>
      <li>BABAHOYO</li>
      <li>CHONE</li>
      <li>DAULE</li>
      <li>DURAN</li>
      <li>GUAYAQUIL</li>
      <li>GUAYAQUIL SUR</li>
      <li>PORTOVIEJO</li>
      <li>SANTA ELENA</li>
      <li>MMEE GUAYAQUIL</li>
      <li>ESMERALDAS</li>
      <li>IBARRA</li>
      <li>LAGO AGRIO</li>
      <li>QUEVEDO</li>
      <li>QUITO</li>
      <li>QUITO NORTE</li>
      <li>QUITO VALLE</li>
      <li>SANTO DOMINGO</li>
      <li>AMBATO</li>
      <li>CUENCA</li>
      <li>LOJA</li>
      <li>MACHALA</li>
      <li>PUYO</li>
      <li>RIOBAMBA</li>
    </ul>
  </article>
</div>
